import { jsx, jsxs } from "react/jsx-runtime";
const footerGroups = [
  {
    title: "Support",
    links: [
      { label: "About Us", href: "https://myetgo.com/about" },
      { label: "Contact Us", href: "https://myetgo.com/support" }
    ]
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", href: "https://myetgo.com/privacy-policy" }
    ]
  }
];
function AIFooter() {
  return /* @__PURE__ */ jsx("footer", { style: { backgroundColor: "#0a0a14", borderTop: "1px solid rgba(255,255,255,0.06)" }, children: /* @__PURE__ */ jsxs("div", { className: "max-w-7xl mx-auto px-6 py-14", children: [
    /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10", children: [
      footerGroups.map((group) => /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx("h3", { style: { fontFamily: "'Manrope',sans-serif", fontWeight: 800, fontSize: "0.8rem", color: "rgba(255,255,255,0.42)", letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: "1rem" }, children: group.title }),
        /* @__PURE__ */ jsx("ul", { className: "flex flex-col gap-3", children: group.links.map((link) => /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(
          "a",
          {
            href: link.href,
            target: "_blank",
            rel: "noreferrer",
            style: { fontFamily: "'Inter',sans-serif", fontSize: "0.95rem", color: "rgba(255,255,255,0.72)", transition: "color 0.2s" },
            onMouseEnter: (event) => event.currentTarget.style.color = "#a78bfa",
            onMouseLeave: (event) => event.currentTarget.style.color = "rgba(255,255,255,0.72)",
            children: link.label
          }
        ) }, link.label)) })
      ] }, group.title)),
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx("h3", { style: { fontFamily: "'Manrope',sans-serif", fontWeight: 800, fontSize: "0.8rem", color: "rgba(255,255,255,0.42)", letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: "1rem" }, children: "Connect With Us" }),
        /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-3", children: [
          /* @__PURE__ */ jsx(
            "a",
            {
              href: "https://www.instagram.com/etgo.app?igsh=MTJweGZ6ZjR6YWk0NQ==",
              target: "_blank",
              rel: "noreferrer",
              className: "inline-flex items-center gap-3",
              style: { fontFamily: "'Inter',sans-serif", fontSize: "0.95rem", color: "rgba(255,255,255,0.72)" },
              children: "Instagram"
            }
          ),
          /* @__PURE__ */ jsx(
            "a",
            {
              href: "https://www.facebook.com/share/19WnXk1S3q/?mibextid=wwXIfr",
              target: "_blank",
              rel: "noreferrer",
              className: "inline-flex items-center gap-3",
              style: { fontFamily: "'Inter',sans-serif", fontSize: "0.95rem", color: "rgba(255,255,255,0.72)" },
              children: "Facebook"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx("h3", { style: { fontFamily: "'Manrope',sans-serif", fontWeight: 800, fontSize: "0.8rem", color: "rgba(255,255,255,0.42)", letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: "1rem" }, children: "Get the App" }),
        /* @__PURE__ */ jsx("div", { className: "flex flex-col gap-3", children: ["Google Play", "App Store"].map((store) => /* @__PURE__ */ jsx(
          "a",
          {
            href: "#",
            className: "inline-flex min-h-11 items-center justify-center rounded-xl border px-5 font-semibold transition-all hover:-translate-y-0.5",
            style: { fontFamily: "'Manrope',sans-serif", fontSize: "0.9rem", color: "white", borderColor: "rgba(255,255,255,0.12)", backgroundColor: "rgba(255,255,255,0.06)" },
            children: store
          },
          store
        )) })
      ] })
    ] }),
    /* @__PURE__ */ jsx(
      "p",
      {
        className: "mt-12 pt-7 text-center",
        style: { fontFamily: "'Inter',sans-serif", fontSize: "0.82rem", color: "rgba(255,255,255,0.42)", borderTop: "1px solid rgba(255,255,255,0.06)" },
        children: "\xA9 2026 MagicBeans Solutions, LLC. All Rights Reserved."
      }
    )
  ] }) });
}
export {
  AIFooter
};
